
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 85.337h512v341.326H0z"}}),_c('g',{attrs:{"fill":"#0052B4"}},[_c('path',{attrs:{"d":"M0 85.337h512v113.775H0zM0 312.888h512v113.775H0z"}})]),_c('path',{attrs:{"fill":"#FFDA44","d":"M228.582 261.936L256 214.447l27.418 47.489z"}}),_c('path',{attrs:{"fill":"#6DA544","d":"M291.616 277.616L256 295.425l-35.616-17.809v-23.744h71.232z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M289.579 216.485l-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"}})])
          )
        }
      }
    